import React, { useState, Fragment } from "react";
import { Event, PageConfigurationContextConsumer } from "./index";
import GetNotifiedPopup from "./GetNotifiedPopup";
import _ from "lodash";
import "./styles/upcoming-events.css";
import UpcomingEventCard from "./UpcomingEventCard";
// @ts-ignore
import Pluralize from "react-pluralize";
import Megaphone2 from "./vectors/Megaphone2";
import ContrastForegroundUtility from "../../utils/ContrastForegroundUtility";

const backIcon = require("./styles/back.svg");

export type Filters = {
  name: string | null;
  searchableAddress: string | null;
  [key: string]: string | null;
};

const UpcomingEvents = ({
  events,
  showCompletedEvents,
  hasCompletedEvents,
  bulkRegisterCustomerLeadAPI
}: {
  events: Event[];
  showCompletedEvents: () => void;
  hasCompletedEvents: boolean;
  bulkRegisterCustomerLeadAPI: string;
}) => {
  const [showCustomerLeadsModal, setShowCustomerLeadsModal] = useState(false);
  const [selectedEvents, setSelectedEvents] = useState<Event[]>([]);
  const [filters, updateFilters] = useState<Filters>({
    name: null,
    searchableAddress: null
  });

  const handleEventSelection = (e: any, newEvent: Event) => {
    if (e.target.checked)
      setSelectedEvents(selectedEvents => [...selectedEvents, newEvent]);
    else
      setSelectedEvents(
        selectedEvents.filter(event => event.id != newEvent.id)
      );
  };

  const eventsToDisplay = () =>
    events.filter(event =>
      _.every(
        _.map(_.keys(filters), column => {
          if (filters[column])
            return (
              // @ts-ignore
              _.toLower(event[column]).indexOf(_.toLower(filters[column])) > -1
            );
          else return true;
        })
      )
    );

  const isEventSelected = (event: Event) => _.includes(selectedEvents, event);

  const clearSelection = () => {
    setShowCustomerLeadsModal(false);
    setSelectedEvents([]);
  };

  return (
    <PageConfigurationContextConsumer>
      {pageConfiguration =>
        pageConfiguration && (
          <div className="container">
            <div className="upcoming-ev-header-container">
              <div className="upcoming-ev-header-tab-div">
                <p className={"upcoming-ev-header-tab"}>
                  {hasCompletedEvents && (
                    <button
                      className="upcoming-ev-back-btn"
                      onClick={showCompletedEvents}
                    >
                      <img src={backIcon} />
                    </button>
                  )}
                  Upcoming Events
                </p>
              </div>
            </div>

            <div
              className="notify-banner-container"
              style={{ backgroundColor: pageConfiguration.primaryColor }}
            >
              <div className="notify-banner-div-1">
                <div className="notify-banner-img-div">
                  <Megaphone2 color={pageConfiguration.secondaryColor} />
                </div>
                <div
                  className={`notify-banner-info-div ${ContrastForegroundUtility.fgClass(
                    pageConfiguration.primaryColor
                  )}`}
                >
                  <p className="notify-banner-p1">
                    Select Events and Get Notified
                  </p>
                  <p className="notify-banner-p2">
                    Get notified when new albums are uploaded to the selected
                    events
                  </p>
                </div>
              </div>
              <div className="notify-banner-btn-div">
                <span
                  className={`notify-banner-btn-span ${ContrastForegroundUtility.fgClass(
                    pageConfiguration.primaryColor
                  )}`}
                >
                  <Pluralize singular="event" count={selectedEvents.length} />{" "}
                  selected
                </span>
                <button
                  className="notify-banner-btn"
                  onClick={e => setShowCustomerLeadsModal(true)}
                  disabled={selectedEvents.length == 0}
                >
                  Notify Me
                </button>
              </div>
            </div>

            <div className="upcoming-ev-container">
              {eventsToDisplay().map((event, _) => {
                return (
                  <UpcomingEventCard
                    key={event.id}
                    event={event}
                    handleEventSelection={handleEventSelection}
                    isEventSelected={isEventSelected}
                  />
                );
              })}
            </div>

            {selectedEvents.length ? (
              <p className="notify-text-bottom">
                Get notified for{" "}
                <Pluralize singular="event" count={selectedEvents.length} />
              </p>
            ) : (
              <p className="notify-text-bottom">
                Select Events and Get Notified
              </p>
            )}
            <button
              className={`notify-btn-bottom ${ContrastForegroundUtility.fgClass(
                pageConfiguration.accentColor
              )}`}
              style={{ backgroundColor: pageConfiguration.accentColor }}
              onClick={e => setShowCustomerLeadsModal(true)}
              disabled={selectedEvents.length == 0}
            >
              Notify Me
            </button>

            {showCustomerLeadsModal && (
              <GetNotifiedPopup
                events={selectedEvents}
                bulkRegisterCustomerLeadAPI={bulkRegisterCustomerLeadAPI}
                clearSelection={clearSelection}
              />
            )}
          </div>
        )
      }
    </PageConfigurationContextConsumer>
  );
};

export default UpcomingEvents;
